//natives
import React, { Component } from 'react';
import Cookies from 'universal-cookie';
// import TagManager from 'react-gtm-module';

//childrens
import FuncionalidadesLista from '../childrens/funcionalidadesLista/.mixins';
import Columns from '../childrens/columns/.mixins';
import CustomToolbar from '../childrens/customToolbar/.mixins';
import DialogCancel from '../childrens/dialogCancel/.mixins';
import DialogConfirm from '../childrens/dialogConfirm/.mixins';

//components
import Alerta from "../../../../../../../../../util/snackbars/.mixins/";
import { AuthContext } from '../../../../../../../../../../contexts/AuthContext';

//controllers
import Funcionalidade_controller from '../../../../../../../../../../controllers/funcionalidade';
import PermissaoFuncionalidade_controller from '../../../../../../../../../../controllers/permissaoFuncionalidade';
import Permissao_controller from '../../../../../../../../../../controllers/permissao';
import Config from '../../../../../../../../../../controllers/config';
import Log from '../../../../../../../../../../controllers/log';

export default class Funcionalidades extends Component {
    static contextType = AuthContext;

    constructor(props) {
        super(props);

        this.child = React.createRef();
        this.inputRef = React.createRef();
        this.role = "",
        
        this.state = {
            title: '',
            itens: [],
            itensTable: [],
            itensAlterados: [],
            columns: [],
            isLoading: true,
            isError: false,
            error: null,
            rowsPerPage: 10000,
            rowsPerPageOptions: [10000],
            customToolbar: null,
            customFooter: () => <></>,
            openCancel: false,
            openConfirm: false,
        };

        this.loadData = this.loadData.bind(this);
        this.setState = this.setState.bind(this);
        this.handlerSwitch = this.handlerSwitch.bind(this);
        this.handleCancelar = this.handleCancelar.bind(this);
        this.handleConfirm = this.handleConfirm.bind(this);
        this.handleDialogCancelarOpen = this.handleDialogCancelarOpen.bind(this);
        this.handleDialogConfirmOpen = this.handleDialogConfirmOpen.bind(this);
        this.handleDialogCancelClose = this.handleDialogCancelClose.bind(this);
        this.handleDialogConfirmClose = this.handleDialogConfirmClose.bind(this);
    }
    
    async componentDidMount() {
        this.role = this.context.user.role;
        
        //auditoria
        const cookies = new Cookies();
        const token = cookies.get('User-Token');
        Log.info(token,"Efetuado carregamento da tela Funcionalidade!");

        var id = this.props.props.params.id;
        var filters = {
            permissao_id_md5: id
        };
        await this.loadPermissao(this, filters);
        await this.loadData(filters);
    }

    handleDialogCancelarOpen = () => {
        this.setState({openCancel:true});
    };

    handleDialogConfirmOpen = () => {
        this.setState({openConfirm:true});
    };

    handleDialogCancelClose = () => {
        this.setState({openCancel:false});
    };

    handleDialogConfirmClose = () => {
        this.setState({openConfirm:false});
    };

    handleCancelar() {
        this.handleDialogCancelClose();
        this.refresh();
    }

    requests() {
        return new Promise((resolve,reject) => {
            var count = 0;
            this.state.itensAlterados.forEach(async element => {

                const cookies = new Cookies();
                const token = cookies.get('User-Token');
                
                try {
                    const filters = {
                        permissao_id_md5: this.props.props.params.id,
                        funcionalidade_id_md5: element.id_md5
                    };
                    var r_funcionalidade = null;
                    var j_r_funcionalidade = null;
                    
                    if (!element.value) {
                        r_funcionalidade = await PermissaoFuncionalidade_controller.remove(token,filters);
                        j_r_funcionalidade = JSON.parse(r_funcionalidade.body);
                    } else {
                        r_funcionalidade = await PermissaoFuncionalidade_controller.post(token,filters);
                        j_r_funcionalidade = JSON.parse(r_funcionalidade.body);
                    }
                    
                    if (r_funcionalidade.res.statusCode === 200) {
                        count++;
                    } else {
                        throw new Error("Campos necessários, não foram retornados pelo servidor!");
                    }

                    if (count === this.state.itensAlterados.length) {
                        
                        // TagManager.dataLayer({
                        //     dataLayer: {
                        //     event: 'event',
                        //     eventCategory: 'tokstok:fornecedores:funcionalidades',
                        //     eventAction: 'callback',
                        //     eventLabel: 'sucesso:confirmacao-lista-enviada',
                        //     }
                        // });

                        resolve();
                    }
                } catch (error) {
                    this.child.current.retorno('Erro ao carregar dados!','error');
                    var errorString = "Erro ao carregar dados!";
                    if (Config.DEBUG === "TRUE")
                        errorString = error.message;
                    this.setState({
                        isError: true,
                        isLoading: false,
                        error: errorString
                    });

                    // TagManager.dataLayer({
                    //     dataLayer: {
                    //       event: 'event',
                    //       eventCategory: 'tokstok:fornecedores:funcionalidades',
                    //       eventAction: 'callback',
                    //       eventLabel: `erro:${error.message}`,
                    //     }
                    // });
    
                    //auditoria
                    var str = "Erro no envio de dados de funcionalidade! "
                    +"Error:( Message: "+error.message+", Stack: "+error.stack+" )";
                    Log.error(token,str);
                }

            });
        });
    }

    async handleConfirm() {
        this.handleDialogConfirmClose();
        this.setState({isLoading:true});
        await this.requests();
        this.child.current.retorno('Alteração realizada!','success');
        if (this.state.title == this.role) {
            setTimeout(() => {
                window.location.reload();
            }, 300);
        } else {
            setTimeout(() => {
                this.refresh();
            }, 300);
        }
    }

    async refresh() {
        this.setState({
            isLoading: true,
            itensAlterados:[],
        });
        var id = this.props.props.params.id;
        var filters = {
            permissao_id_md5: id
        };
        await this.loadData(filters);
        this.setState({
            isLoading: false
        });
    }

    handlerSwitch(id_md5) {

        var newItensAlterados = this.state.itensAlterados;
        var newItens = this.state.itens;
        var newItensTable = this.state.itensTable;

        const index = newItensAlterados.findIndex(element=>element.id_md5===id_md5);
        if (index>-1) {
            newItensAlterados.splice(index,1);
        } else {
            const item = this.state.itens.filter(element=>element.id_md5===id_md5);
            newItensAlterados.push(item[0]);
        }

        const i = this.state.itens.findIndex(element=>element.id_md5===id_md5);
        newItens[i].value = !(newItens[i].value);
        newItensTable[i].value.value = !(newItensTable[i].value.value);
        
        this.setState({
            itens: newItens,
            itensTable: newItensTable,
            itensAlterados:newItensAlterados
        });

    };

    async loadData(filters) {
        
        const cookies = new Cookies();
        const token = cookies.get('User-Token');
        
        try {
            
            var j_funcionalidade = null;
            var o_funcionalidade = null;

            if (this.props.props.params.id) {
                o_funcionalidade = await Funcionalidade_controller.getByPermissionID(token,filters);
                j_funcionalidade = JSON.parse(o_funcionalidade.body);
            } else {
                o_funcionalidade = await Funcionalidade_controller.get(token);
                j_funcionalidade = JSON.parse(o_funcionalidade.body);
            }
            
            if (o_funcionalidade.res.statusCode === 200) {
                const j_funcionalidade_filter = j_funcionalidade.itens.map(element=>{
                    return {descricao:element.descricao,value:{value:element.value,id_md5:element.id_md5}};
                });
                this.setState({
                    itens: j_funcionalidade.itens,
                    itensTable: j_funcionalidade_filter,
                    isLoading: false,
                    columns: Columns(this),
                    customToolbar:() => <CustomToolbar {...this}/>,
                });

                // TagManager.dataLayer({
                //     dataLayer: {
                //     event: 'event',
                //     eventCategory: 'tokstok:fornecedores:funcionalidades',
                //     eventAction: 'callback',
                //     eventLabel: 'sucesso:lista-funcionalidades',
                //     }
                // });
            } else {
                if (
                    j_funcionalidade.status == false && 
                    j_funcionalidade.message && 
                    j_funcionalidade.message.includes("Token inválido!")
                ) {
                    this.child.current.retorno('Autentificação inválida!','error');
                    setTimeout(() => {
                        window.location.reload();
                    }, 1000);
                } else {
                    throw new Error("Campos necessários, não foram retornados pelo servidor!");
                }
            }

        } catch (error) {
            var errorString = "Erro ao carregar dados!";
            if (Config.DEBUG === "TRUE")
                errorString = error.message;
            this.setState({
                isError: true,
                isLoading: false,
                error: errorString
            });

            // TagManager.dataLayer({
            //     dataLayer: {
            //       event: 'event',
            //       eventCategory: 'tokstok:fornecedores:funcionalidades',
            //       eventAction: 'callback',
            //       eventLabel: `erro:${error.message}`,
            //     }
            // });

            //auditoria
            var str = "Erro na recuperação de dados de funcionalidades! "
            +"Error:( Message: "+error.message+", Stack: "+error.stack+" )";
            Log.error(token,str);
        }

    }

    async loadPermissao(props,filters) {
        const cookies = new Cookies();
        const token = cookies.get('User-Token');
        
        try {
            
            const o_permissao = await Permissao_controller.getByID(token,filters);
            const j_permissao = JSON.parse(o_permissao.body);
            
            if (o_permissao.res.statusCode === 200 && j_permissao.itens.length > 0) {
                
                props.setState({
                    title: j_permissao.itens[0].descricao
                });

                // TagManager.dataLayer({
                //     dataLayer: {
                //       event: 'event',
                //       eventCategory: 'tokstok:fornecedores:funcionalidades',
                //       eventAction: 'callback',
                //       eventLabel: 'sucesso:getone-permissao',
                //     }
                // });

            } else if (j_permissao.itens.length == 0) {
                
            } else {
                throw new Error("Campos necessários, não foram retornados pelo servidor");
            }

        } catch (error) {
            props.child.current.retorno('Erro ao carregar dados!','error');
            var errorString = "Erro ao carregar dados!";
            if (Config.DEBUG === "TRUE")
                errorString = error.message;
            props.setState({
                isError: true,
                isLoading: false,
                error: errorString
            });
            
            // TagManager.dataLayer({
            //     dataLayer: {
            //       event: 'event',
            //       eventCategory: 'tokstok:fornecedores:funcionalidades',
            //       eventAction: 'callback',
            //       eventLabel: `erro:${error.message}`,
            //     }
            // });

            //auditoria
            var str = "Erro na recuperação de dados de permissões! "
            +"Error:( Message: "+error.message+", Stack: "+error.stack+" )";
            Log.error(token,str);
        }

    }

    render() {
        return (
            <div style={{width:'100%'}}>
                <FuncionalidadesLista {...this}/>
                <DialogCancel {...this}/>
                <DialogConfirm {...this}/>
                <Alerta ref={this.child}/>
            </div>
        );
    }

}